import { Component, OnInit, Inject } from '@angular/core';
import { DocusignService } from '../../data/docusign.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { DocusignEnvelope } from '../../data/docusign-envelope.ts';
import { trackEntityById } from 'projects/core/src/public-api';
import { environment } from 'projects/desktop/src/environments/environment';

@Component({
  selector: 'app-envelops-dialog',
  templateUrl: './envelops-dialog.component.html',
  styleUrls: ['./envelops-dialog.component.scss']
})
export class EnvelopsDialogComponent implements OnInit {

  projectName: string

  sortMap = new Map();

  contentLoading = true;

  listToShow: DocusignEnvelope[] = [];
  copyList: DocusignEnvelope[];

  trackEntityById = trackEntityById;

  deleteIdSpinner = -1;

  constructor(
    protected docusignService: DocusignService,
    @Inject(MAT_DIALOG_DATA) private data: {
      projectNumber: number,
      projectName: string
    }
  ) {
    this.projectName = this.data.projectName
  }

  ngOnInit(): void {
    this.getInfo()
  }

  getInfo() {
    this.listToShow = [];
    this.copyList = [];

    this.nullifyMap();
    this.contentLoading = true;
    this.docusignService.getEnvelopes(this.data.projectNumber).subscribe(result => {
      this.listToShow = result;
      this.copyList = [...this.listToShow];

      this.contentLoading = false;

      this.sortByLabel('createdDate');

    }, error => {
      this.contentLoading = false;
    })
  }

  nullifyMap() {
    this.sortMap.set('id', 0);
    this.sortMap.set('createdDate', 0);
    this.sortMap.set('status', 0);
    this.sortMap.set('sentDate', 0);
    this.sortMap.set('signedDate', 0);
  }

  countMap(param: string) {
    let num = this.sortMap.get(param);
    if(num === 1) {
      num++;
    } else if(num === 0) {
      this.nullifyMap();
      num++;
    } else if(num === 2) {
      num = 0;
    }

    this.sortMap.set(param, num);
  }

  sortByLabel(param: string) {
    if(!this.contentLoading) {

      this.countMap(param);
      let numm = 1;
      if(this.sortMap.get(param) === 2) numm = -1;
      if(this.sortMap.get(param) === 0) {
        this.listToShow = [...this.copyList];
        return
      }
      ;

      this.listToShow.sort((a, b) => {
        const oldDate = new Date('2017-01-01');
        if(param === 'createdDate') {
          const bTime = (b.createdDate ? b.createdDate.getTime() : oldDate.getTime()) as number;
          const aTime = (a.createdDate ? a.createdDate.getTime() : oldDate.getTime()) as number;
          return (bTime - aTime) * numm;
        }
        if(param === 'status') {
          return ('' + a.status).localeCompare(b.status) * numm;
        }
        if(param === 'sentDate') {
          const bTime = (b.sentDate ? b.sentDate.getTime() : oldDate.getTime()) as number;
          const aTime = (a.sentDate ? a.sentDate.getTime() : oldDate.getTime()) as number;
          return (bTime - aTime) * numm;
        }
        if(param === 'signedDate') {
          const bTime = (b.signedDate ? b.signedDate.getTime() : oldDate.getTime()) as number;
          const aTime = (a.signedDate ? a.signedDate.getTime() : oldDate.getTime()) as number;
          return (bTime - aTime) * numm;
        }

        return (b[param] - a[param]) * numm
      })
    }
  }

  openDocu(env: DocusignEnvelope) {
    let baseLink = `https://app.docusign.com`;

    if(environment.dev) {
      baseLink = `https://appdemo.docusign.com`
    }

    window.open(`${baseLink}/documents/details/${env.envelopeId}`, '_blank');
  }

  deleteDocu(env: DocusignEnvelope) {
    this.deleteIdSpinner = env.id;

    this.docusignService.deleteEnvelope(env.envelopeId).subscribe(emit => {
      let fIndex = this.listToShow.findIndex(envv => envv.id === env.id)
      if(fIndex >= 0) {
        this.listToShow.splice(fIndex, 1)
      }

      fIndex = this.copyList.findIndex(envv => envv.id === env.id)
      if(fIndex >= 0) {
        this.copyList.splice(fIndex, 1)
      }

      this.deleteIdSpinner = -1;
    }, error => {
      this.deleteIdSpinner = -1;
    })
  }

}
